import { useState } from 'react';
import PageContainer from 'src/pages/components/PageContainer';
import EezyGuardOccurrenceList from 'src/pages/components/eezyguard/EezyGuardOccurrenceList';
import { useEezyguardAdmin } from 'src/pages/components/eezyguard/common';

export default function EezyGuardAdminOccurrences(): JSX.Element {
  const { isAdmin } = useEezyguardAdmin();
  const [error, setError] = useState('');

  return (
    <PageContainer title="Todas as Ocorrências" error={error} guard={() => isAdmin}>
      <EezyGuardOccurrenceList scope="admin" onError={setError} />
    </PageContainer>
  );
}
